// @ts-nocheck
import React, { FC, useState } from 'react'
import { useGetDetailUnitMutation } from '@/modules/maps/services/homeMapService'
import { TLineUnit } from '@/modules/maps/types/unitsMapType'
import {
  balloonRed,
  balloonYellow,
  lineGreen,
  getBalloonHtml,
} from '@/modules/maps/utils/balloons'
import car from '@/assets/img/car.png'
import { useMediaQuery } from '@mui/material'
import { Polyline, Placemark } from '@pbe/react-yandex-maps'
import { getLineColor } from '@/components/Organisms/Map/MapLightnings'
import iconOpora from '@/assets/img/icons/opora.png'
import iconLight from '@/assets/img/icons/light-on.png'
import iconSun from '@/assets/img/icons/sun.png'
import iconWidth from '@/assets/img/icons/width.png'

interface Props {
  unit: TLineUnit
}

const MyPolyLine: FC<Props> = ({ unit }) => {
  const isMobile = useMediaQuery('(max-width:767px)')
  const [getDetailUnit, { isLoading, isError }] = useGetDetailUnitMutation()
  const [isHovered, setIsHovered] = useState(false)
  // @ts-ignore
  const [unitData, setUnitData] = useState<TLineUnit>({
    id: 0,
    name: '',
    address: '',
    coordinates: '',
  })

  const onLoadData = async (id: number) => {
    try {
      const res = await getDetailUnit(id).unwrap()
      if (Object.values(res).length > 0) {
        // @ts-ignore
        setUnitData(() => res)
      }
    } catch (e) {
      console.error(e)
    }
  }

  if (!unit.coordinates) return null

  // Получаем первую и последнюю точки линии
  const firstPoint = unit.coordinates[0]
  const lastPoint = unit.coordinates[unit.coordinates.length - 1]
  const lineColor = getLineColor(unit?.lightingTypeId)

  const balloonData = {
    isLoading,
    isError,
    title: `${unitData.type} ${unitData?.name}`,
    titleLink: `/devices/${unitData?.id}`,
    imgUrl: unitData?.imageUrl,
    description: unitData?.address,
    icons: [
      {
        text: `${unitData?.lightingLength || 0} м`,
        iconSrc: iconWidth,
        helperText: 'Протяженность',
      },
      {
        text: unitData?.lightingPoles || 0,
        iconSrc: iconLight,
        helperText: 'Светильники',
      },
      {
        text: unitData?.lightingLuminaires,
        iconSrc: iconOpora,
        helperText: 'Опоры',
      },
      {
        text: `${unitData?.lightingPower || 0} кВт`,
        iconSrc: iconSun,
        helperText: 'Мощность',
      },
    ],
  }

  return (
    <>
      <Polyline
        geometry={unit.coordinates}
        onClick={() => {
          onLoadData(unit.id)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        options={{
          strokeColor: lineColor,
          strokeWidth: 4,
          strokeOpacity: isHovered ? 1 : 0.7,
        }}
        properties={{
          balloonContentBody: getBalloonHtml(balloonData),
        }}
      />
      {/* Маркер начала линии */}
      <Placemark
        geometry={firstPoint}
        onClick={() => {
          onLoadData(unit.id)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        properties={{
          balloonContentBody: getBalloonHtml(balloonData),
        }}
        options={{
          preset: 'islands#circleDotIcon',
          iconColor: lineColor,
        }}
      />
      {/* Маркер конца линии */}
      <Placemark
        geometry={lastPoint}
        onClick={() => {
          onLoadData(unit.id)
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        properties={{
          balloonContentBody: getBalloonHtml(balloonData),
        }}
        options={{
          preset: 'islands#circleDotIcon',
          iconColor: lineColor,
        }}
      />
    </>
  )
}

export default MyPolyLine
